module.exports = __webpack_public_path__ + "static/media/Portrait-10057.ac0fb6cf.jpg";